/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint no-useless-constructor: 0 */
/* eslint camelcase: 0 */
import * as Blockly from 'blockly';
import { FieldGridDropdown } from '@blockly/field-grid-dropdown';


export class JuniorFieldGridDropdown extends FieldGridDropdown {
  constructor(menuGenerator, validator, config) {
    super(menuGenerator, validator, config);
  }

  applyColour() {
    super.applyColour();
    // hack to update arrow disabled state
    let fill = (this.constants_) ? `url(#${this.constants_.disabledPatternId})` : '#FFAB19';
    const colours = this.getColours();
    if (colours && this.sourceBlock_.isEnabled()) {
      fill = colours.primary;
    }
    if (this.svgArrowBG) {
      this.svgArrowBG.setAttribute(
        'fill',
        `${fill}`,
      );
    }
  }

  initView() {
    // Como en prod, el ícono grande es decorativo y solo la flecha abre el selector: el clickTarget_
    // es arrowGroup_ (ver createSVGArrow_), no fieldGroup_, que cubre casi todo el bloque.
    this.createTextElement_();

    this.imageElement = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {}, this.fieldGroup_);

    this.createSVGArrow_();

    // Blockly deserializa con loadState()/fromXml() antes de initSvg(): aplicar la opción `selected`
    // sin esta guarda pisaría el valor guardado del proyecto. Solo aplica a bloques nuevos.
    if (!this.valueWasLoaded_ && this.menuGenerator_ && Array.isArray(this.menuGenerator_)) {
      this.menuGenerator_.map((value) => {
        if (value[0].selected) {
          this.selectedOption = value;
          this.setValue(this.selectedOption[1]);
        }
        return true;
      });
    }
  }

  loadState(state) {
    this.valueWasLoaded_ = true;
    super.loadState(state);
  }

  fromXml(fieldElement) {
    this.valueWasLoaded_ = true;
    super.fromXml(fieldElement);
  }

  getScaledBBox() {
    // Sin borderRect_ (initView no llama a super), el getScaledBBox de v13 mide el bloque entero y
    // el DropDownDiv queda mal anclado; se devuelve el rect real del field.
    const block = this.getSourceBlock();
    if (!block) {
      throw new Blockly.UnattachedFieldError();
    }
    return Blockly.utils.Rect.from(this.fieldGroup_.getBoundingClientRect());
  }

  createSVGArrow_() {
    let fill = '#FFAB19';
    let stroke = '#CF8B17';
    const colours = this.getColours();
    if (colours && colours.border) {
      fill = colours.primary;
      stroke = colours.border;
    }
    this.arrowGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, this.fieldGroup_);

    this.svgArrowBG = Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.PATH,
      {
        class: 'blocklyPath',
        stroke,
        fill,
        'fill-opacity': '1',
        d: 'm 16,0 A 16,16 0 0,0 0,16 V 16 a 16,16 0 0,0 16,16 H 32 a 16,16 0 0,0 16,-16 v 0 a 16,16 0 0,0 -16,-16 z',
      },
      this.arrowGroup_,
    );

    this.svgArrow = Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.IMAGE,
      {
        height: (this.getConstants()) ? `${this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE}px` : '0px',
        width: (this.getConstants()) ? `${this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE}px` : '0px',
      },
      this.arrowGroup_,
    );
    if (this.svgArrow) {
      this.svgArrow.setAttributeNS(
        Blockly.utils.dom.XLINK_NS,
        'xlink:href',
        (this.getConstants()) ? this.getConstants().FIELD_DROPDOWN_SVG_ARROW_DATAURI : null,
      );
    }

    this.clickTarget_ = this.arrowGroup_;
  }

  positionSVGArrow(x, y) {
    if (!this.svgArrow) {
      return 0;
    }
    const offsetY = 20;
    const block = this.getSourceBlock();
    if (!block) {
      throw new Blockly.UnattachedFieldError();
    }
    const textPadding = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING || 0;
    const svgArrowSize = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE || 0;
    const xPos = (this.selectedOption[0].width / 2) - (this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2);
    const yPos = this.selectedOption[0].height + offsetY;
    this.svgArrow.setAttribute(
      'transform',
      `translate(${xPos},${yPos})`,
    );
    this.svgArrowBG.setAttribute(
      'transform',
      `translate(${xPos - 18},${yPos - 10})`,
    );
    // return svgArrowSize + textPadding;
    return 0;
  }

  showEditor_(e) {
    super.showEditor_(e);

    const colours = this.getColours();
    if (colours && colours.border) {
      Blockly.DropDownDiv.setColour(colours.primary, colours.border);
    }

    const menuElementGrid = (this.menu_) ? this.menu_.getElement() : null;
    if (menuElementGrid) {
      Blockly.utils.dom.addClass(menuElementGrid, 'fieldGridDropDownContainer');
    }
    // No llamar a DropDownDiv.show() otra vez: super.showEditor_ ya lo muestra y un segundo show()
    // lo cierra al instante.

    // TODO: hack to draw dropdown widget on top of the rest of the page elements.
    // Check why is Lab's theme overwriting the z-index of the dropdown.
    if (document.querySelector('.blocklyDropDownDiv')) {
      const dropDownDiv = document.querySelector('.blocklyDropDownDiv');
      dropDownDiv.style.setProperty('z-index', '1000', 'important');
    }
  }
}